module.exports = __webpack_public_path__ + "img/NO998997801.bbc6094a.png";